import * as _ from 'lodash'

export abstract class BaseModel<T> {
  static DEFAULT_ATTRIBUTES = {}

  id: number

  constructor(attributes: Object = {}) {
    if(attributes['id']) {
      Object.assign(this, attributes)
    } else {
      let defaultAttributes = this.constructor['DEFAULT_ATTRIBUTES'] ? _.cloneDeep(this.constructor['DEFAULT_ATTRIBUTES']) : {}
      Object.assign(this, defaultAttributes, attributes)
    }
  }

  persisted(): boolean {
    return !!this.id
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/base.model.ts